import {
  Component,
  Injector,
  OnInit,
  ViewEncapsulation,
  NgZone,
  Input,
} from '@angular/core';
import { AppComponentBase } from '@shared/common/app-component-base';
import { Router } from '@angular/router';
import {
  NotificationServiceProxy,
  UserNotification,
} from '@shared/service-proxies/service-proxies';
import {
  IFormattedUserNotification,
  UserNotificationHelper,
} from './UserNotificationHelper';

import { UrlHelper } from '@shared/helpers/UrlHelper';

@Component({
  templateUrl: './recent-notifications.component.html',
  styleUrls: ['./recent-notifications.component.less'],
  selector: 'recent-notifications',
  encapsulation: ViewEncapsulation.None,
})
export class RecentNotificationsComponent
  extends AppComponentBase
  implements OnInit {
  notifications: IFormattedUserNotification[] = [];
  unreadNotificationCount = 0;
  @Input() isDropup = false;
  @Input() customStyle = 'btn btn-icon btn-dropdown btn-clean btn-lg mr-1';

  constructor(
    injector: Injector,
    private _router: Router,
    private _notificationService: NotificationServiceProxy,
    private _userNotificationHelper: UserNotificationHelper,
    public _zone: NgZone
  ) {
    super(injector);
  }

  ngOnInit(): void {
    this.loadNotifications();
  }

  loadNotifications(): void {
    if (UrlHelper.isInstallUrl(location.href)) {
      return;
    }

    this._notificationService
      .getUserNotifications(0, undefined, undefined, 5, 0)
      .subscribe((result) => {
        this.unreadNotificationCount = result.unreadCount;
        this.notifications = [];
        result.items.forEach( (item: UserNotification) => {
          if(item.notification.notificationName!=='App.CurrentProjectCacheEmpty')
          {
            const formattedRecord = this._userNotificationHelper.format(<any>item, false);
            formattedRecord.text = abp.utils.truncateStringWithPostfix(formattedRecord.text, 122);
            this.notifications.push(formattedRecord);
          }
        });
      });
  }

  truncateString(text: any, length: number): string {
    return abp.utils.truncateStringWithPostfix(text, length);
  }

  gotoUrl(url): void {
    if (url) {
      location.href = url;
    }
  }

  removeRecentNotification(data: any): void {
    this.spinnerService.show();
    this._userNotificationHelper.setAsRead(data.userNotificationId, () => {
        this.loadNotifications();
        this.spinnerService.hide();
    });
  }

  goToAllNotifications() {
        this._router.navigateByUrl(
        '/app/notifications'
        );
  }
}
